import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithHttpStatus } from '../services/baseQuery';

// Define a service using a base URL and expected endpoints
export const companyStore = createApi({
    reducerPath: 'companyStore',
    baseQuery: baseQueryWithHttpStatus,
    endpoints: (builder) => ({
        getOrgDocuments: builder.mutation({
            query: (body) => {
                return {
                    url: "assetsDocument/getOrgDocumentData/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        uploadOrgDocument: builder.mutation({
            query: (body) => {
                return {
                    url: "assetsDocument/uploadOrgDocument/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        sendCompanyDocumentEmail: builder.mutation({
            query: (body) => {
                return {
                    url: "assetsDocument/sendCompanyDocumentEmail/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
    }),
})

export const {
    useGetOrgDocumentsMutation,
    useUploadOrgDocumentMutation,
    useSendCompanyDocumentEmailMutation,
} = companyStore;